export default {
    LIMPAR_FILTROS_BUSCA_LICITACAO: 'limparFiltrosBuscaLicitacao',
    LOKI: {
        DISABLE_GLOBAL_LOADING: 'disableGlobalLoading',
        ENABLE_GLOBAL_LOADING: 'enableGlobalLoading',
        SET_GLOBAL_LOADING: 'setGlobalLoading',
        SET_LOADING_MESSAGE: 'setLoadingMessage',
        SET_TIMEZONE: 'setTimezone',
        SET_ACCESS_TOKEN: 'setAccessToken',
        SET_LACUNA_LICENSE: 'setLacunaLicense',
        SET_REMOVER_ANEXOS_LOKI: 'setRemoverAnexosLoki',
    },
    MOSTRAR_MENSAGEM_ERRO: 'mostrarMensagemErro',
    MOSTRAR_MENSAGEM_ERRO_DEFAULT: 'mostrarMensagemErroDefault',
    MOSTRAR_MENSAGEM_ERRO_PERDA_SESSAO: 'mostrarMensagemErroPerdaSessao',
    MOSTRAR_MENSAGEM_SEM_PERMISSAO_ACESSO: 'mostrarMensagemSemPermissaoAcesso',
    MOSTRAR_MENSAGEM_SUCESSO_DEFAULT: 'mostrarMensagemSucessoDefault',
    MOSTRAR_MENSAGEM_WARNING: 'mostrarMensagemWarning',
    MOSTRAR_MENSAGEM_SUCESSO: 'mostrarMensagemSucesso',
    RESETAR_PAGINA_DOCUMENTOS_VIRTUALIZADOS: 'resetarPaginaDocumentosVirtualizados',
    LIMPAR_FILTROS_BUSCA_COMISSAO: 'limparFiltrosBuscaComissao',
    SET_ANEXOS_LICITACAO: 'setAnexosLicitacao',
    SET_COMISSAO: 'setComissao',
    SET_ESCLARECIMENTOS_LICITACAO: 'setEsclarecimentosLicitacao',
    SET_FILTROS_BUSCA_COMISSAO: 'setFiltrosBuscaComissao',
    SET_PAGINACAO_BUSCA_COMISSAO: 'setPaginacaoBuscaComissao',
    SET_RESETAR_PAGINACAO: 'setResetarPaginacao',
    SET_FILTROS_BUSCA_LICITACAO: 'setFiltrosBuscaLicitacao',
    SET_FILTROS_BUSCA_USUARIO: 'setFiltrosBuscaUsuario',
    SET_FORNECEDOR_ACEITE: 'setFornecedorAceite',
    SET_IMPUGNACOES_LICITACAO: 'setImpugnacoesLicitacao',
    SET_LICITACAO: 'setLicitacao',
    SET_POSSUI_ITEM_COM_PERIODICIDADE: 'setPossuiItemComPeriodicidade',
    SET_LICITACAO_LEGADO: 'setLicitacaoLegado',
    SET_ESCLARECIMENTOS_IMPUGNACAOES_LEGADO: 'setEsclarecimentosImpugnacoesLegado',
    SET_LOTES_LICITACAO: 'setLotesLicitacao',
    SET_MENU_AVATAR: 'setMenuAvatar',
    SET_ORGAOS: 'setOrgaos',
    SET_PAGINACAO_BUSCA_LICITACAO: 'setPaginacaoBuscaLicitacao',
    SET_PAGINACAO_BUSCA_LICITACOES_FAVORITAS_FORNECEDOR: 'setPaginacaoBuscaLicitacoesFavoritasFornecedor',
    SET_PAGINACAO_BUSCA_LICITACOES_COM_PROPOSTA_FORNECEDOR: 'setPaginacaoBuscaLicitacoesComPropostaFornecedor',
    SET_PERFIS: 'setPerfis',
    SET_PRODUTO: 'setProduto',
    SET_PROPOSTA_RESUMO: 'setPropostaResumo',
    SET_LICITACAO_PROPOSTA_ITENS: 'setLicitacaoPropostaItens',
    SET_TERMO_ACEITE_PROPOSTA: 'setTermoAceiteProposta',
    SET_PRAZO_PROPOSTA: 'setPrazoProposta',
    SET_URL_COMPRA_DIRETA: 'setUrlCompraDireta',
    SET_USUARIO: 'setUsuario',
    SET_USUARIO_LOGADO: 'setUsuarioLogado',
    SET_FILES_API: 'setFilesApi',
    SET_UFS: 'setUfs',
    SET_PAGINACAO_BUSCA_COBRANCAS_FORNECEDOR: 'setPaginacaoBuscaCobrancasFornecedor',
    SET_AUTOCOMPLETE_IMPORTAR_LICITACAO: 'setAutocompleteImportarLicitacao',
    SET_PARAMETROS: 'setParametros',
    SET_USUARIO_SETUP: 'setUsuarioSetup',
    SET_DOCUMENTOS_VIRTUALIZADOS: 'setDocumentosVirtualizados',
    SET_PAGINACAO_DOCUMENTOS_VIRTUALIZADOS: 'setPaginacaoDocumentosVirtualizados',
    SET_PAGINACAO_BUSCA_HASH: 'setPaginacaoBuscaHash',
    SET_FILTROS_BUSCA_PROTOCOLOS: 'setFiltrosBuscaProtocolos',
    LIMPAR_FILTROS_BUSCA_PROTOCOLO: 'limparFiltrosBuscaProtocolo',
    SET_PAGINACAO_BUSCA_PROTOCOLOS: 'setPaginacaoBuscaProtocolos',
    SET_FILTROS_BUSCA_TERMOS: 'setFiltrosBuscaTermos',
    SET_PAGINACAO_BUSCA_TERMOS: 'setPaginacaoBuscaTermos',
    CREDENCIAMENTO: {
        SET_DOCUMENTOS_VIRTUALIZADOS_CREDENCIAMENTO: 'setDocumentosVirtualizadosCredenciamento',
        LIMPAR_FILTROS_BUSCA_CREDENCIAMENTO: 'limparFiltrosBuscaCredenciamento',
        SET_FILTROS_BUSCA_CREDENCIAMENTO: 'setFiltrosBuscaCredenciamento',
        SET_PAGINACAO_BUSCA_CREDENCIAMENTO: 'setPaginacaoBuscaCredenciamento',
        SET_PAGINACAO_SELECAO_PARTICIPANTES: 'setPaginacaoSelecaoParticipantes',
        SET_PAGINACAO_RESULTADO: 'setPaginacaoResultado',
        SET_ANALISE_SOLICITACAO_CREDENCIAMENTO_EM_ANALISE: 'setAnaliseSolicitacaoCredenciamentoEmAnalise',
        SET_PARTICIPANTE_CREDENCIAMENTO: 'setParticipanteCredenciamento',
        SET_NOVAS_SITUACOES_DOCUMENTOS_CREDENCIAMENTO: 'setNovasSituacoesDocumentosCredenciamento',
        SET_MOSTRAR_MODAL_MOTIVO_REENVIO_DOCUMENTO: 'setModalExibirMotivoReenvioDocumento',
        SET_MOSTRAR_MODAL_SOLICITACAO_ENVIO_DOCUMENTO: 'setModalExibirSolicitacaoEnvioDocumento',
        ANALISE_SOLICITACAO_CREDENCIAMENTO: {
            SET_RELATORIOS_ANALISES_SOLICITACOES_CREDENCIAMENTO: 'setRelatoriosAnalisesSolicitacoesCredenciamento',
        },
        SET_REENVIAR_DOCUMENTOS_DADOS: 'setReenviarDocumentosDados',
        SET_SOLICITACAO_CONTEM_ITENS: 'setSolicitacaoContemItens',
    },
    PUB: {
        SET_HTTP_HEADER: 'setHttpHeader'
    },
}
